import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

/**
 * Service to manage sequential execution of API calls.
 * Ensures createAndUpdateCitations completes before getGeneratedAIUMCData runs.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiSequencingService {
  /**
   * Tracks if createAndUpdateCitations API call is in progress.
   * true = API call in progress
   * false = API call completed or not running
   */
  public citationApiInProgress$ = new BehaviorSubject<boolean>(false);

  constructor() {}

  /**
   * Notify that createAndUpdateCitations API call has started.
   */
  public setCitationApiInProgress(): void {
    this.citationApiInProgress$.next(true);
  }

  /**
   * Notify that createAndUpdateCitations API call has completed (success or failure).
   */
  public setCitationApiCompleted(): void {
    this.citationApiInProgress$.next(false);
  }

  /**
   * Wait for any in-progress createAndUpdateCitations API call to complete.
   * Returns an observable that emits when it's safe to proceed.
   */
  public waitForCitationApiCompletion(): Observable<void> {
    return this.citationApiInProgress$.pipe(
      filter((inProgress) => !inProgress),
      take(1),
      map(() => void 0)
    );
  }

  /**
   * Check if citation API is currently in progress.
   */
  public isCitationApiInProgress(): boolean {
    return this.citationApiInProgress$.value;
  }
}
